import React from "react";
import CustomTabs from "../../Components/CustomTabButton";
import { useTranslation } from "react-i18next";
import { enTranslation } from "../../translation/en/global";
import testcases from "../../Images/Owision/testitudecase.png";
import testrun from "../../Images/Owision/testrun.png";
import milestone from "../../Images/Owision/testitudeMilestone.png";
import configuration from "../../Images/Owision/configuration.png";
import api from "../../Images/Owision/testitudeApi.png";
import dashboard from "../../Images/testitudedasbTab.png";

const TestitudeTabs = () => {
  const { t } = useTranslation();
  const TbasButton = enTranslation.testitude.featurework.buttontext;
  const Content = ({ src }) => (
    <div>
      <img className="h-full w-full" src={src} alt="Image" />{" "}
    </div>
  );

  const tabs = [
    { id: "dashboard", label: TbasButton[0], content: <Content src={dashboard} /> },
    { id: "testcases", label: TbasButton[1], content: <Content src={testcases} /> },
    { id: "testrun", label: TbasButton[2], content: <Content src={testrun} /> },
    { id: "milestone", label: TbasButton[3], content: <Content src={milestone} /> },
    { id: "confirguration", label: TbasButton[4], content: <Content src={configuration} /> },
    { id: "api", label: TbasButton[5], content: <Content src={api} /> },
  ];
  return (
    <div>
      <div className="foodrna-featurework">
        <h2 className="">{t("shopifyStripe.content.feature.title")}</h2>
        <div className="the-art-flavour">
          <CustomTabs tabs={tabs} defaultActiveTab="dashboard" />
        </div>
      </div>
    </div>
  );
};

export default TestitudeTabs;
